import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { SearchColorScheme } from '../_shared/types/search-color-scheme.type';
import { SearchSize } from '../_shared/types/search.type';
import { SpinnerComponent } from '../spinner/spinner.component';
import { IconComponent } from '../icon/icon.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'sirius-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SpinnerComponent, IconComponent, ReactiveFormsModule, TranslateModule, CommonModule]
})
export class SearchComponent implements OnInit {
    @Input() control: FormControl;
    @Input() filterItems: string[] = [];
    @Input() busy = new Observable<boolean>();
    @Input() rounded = false;
    @Input() size: SearchSize = 'medium';
    @Input() colorScheme: SearchColorScheme = 'primary';
    @Input() placeholderKey = 'page.search';

    @Output() valueChange = new EventEmitter<string[]>();
    @Output() submitEvent = new EventEmitter<string>();
    @Output() clearEvent = new EventEmitter<string>();

    @ViewChild('input', { read: ElementRef }) input!: ElementRef;

    @HostBinding('class.sir-is-rounded')
    get isRounded() {
        return this.rounded;
    }

    @HostBinding('class.color-scheme-primary')
    get isPrimary(): boolean {
        return this.colorScheme === 'primary';
    }

    @HostBinding('class.color-scheme-secondary')
    get isSecondary(): boolean {
        return this.colorScheme === 'secondary';
    }

    @HostBinding('class.medium')
    get isMedium(): boolean {
        return this.size === 'medium';
    }

    @HostBinding('class.small')
    get isSmall(): boolean {
        return this.size === 'small';
    }

    @Input()
    set value(val: string) {
        this.control.setValue(val);
    }

    constructor() {
        const fb = inject(FormBuilder);

        this.control = fb.control('');
    }

    ngOnInit(): void {
        this.control.valueChanges.subscribe((x: string) => {
            const matches: string[] = [];

            this.filterItems.forEach((y: string) => {
                if (y.toLowerCase().includes(x.toLowerCase())) matches.push(y);
            });

            this.valueChange.emit(matches);
        });
    }

    clear(): void {
        this.control.setValue('');
        this.input.nativeElement.focus();
        this.clearEvent.emit('');
    }

    submit(): void {
        this.submitEvent.emit(this.control.value);
    }
}
